var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{key:_vm.fullPath,attrs:{"channelUniqueId":_vm.channelUniqueId,"posterUniqueId":_vm.posterUniqueId}})
}
var staticRenderFns = []

export { render, staticRenderFns }